import { render, staticRenderFns } from "./CmgFullScreen.vue?vue&type=template&id=8bbd91cc&scoped=true&lang=pug"
import script from "./cmg-full-screen.ts?vue&type=script&lang=ts&external"
export * from "./cmg-full-screen.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbd91cc",
  null
  
)

export default component.exports